import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardTitle,
  IonFab,
  IonFabButton,
  IonIcon,
} from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { alertSharp } from 'ionicons/icons';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'lib-app-puzzle-localstorage-warning',
  templateUrl: './puzzle-localstorage-warning.component.html',
  styleUrls: ['./puzzle-localstorage-warning.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    IonCard,
    IonCardContent,
    IonCardHeader,
    IonCardTitle,
    IonFab,
    IonFabButton,
    IonIcon,
    TranslateModule,
  ],
})
export class PuzzleLocalstorageWarningComponent {
  url: string;

  constructor() {
    addIcons({ alertSharp });

    this.url = window.location.href;
  }
}
